// extracted by mini-css-extract-plugin
module.exports = {"headerContainer":"Header_headerContainer___deJG","addWidgetButton":"Header_addWidgetButton__22e7M","dashboardTabs":"Header_dashboardTabs__34N41","active":"Header_active__2r1vh"};